import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { FlightMultiOffersCard } from './ui/flight_multi_offers.js';

/** Entrada de catálogo do `flight_multi_offers` (slot chat). Um card por ROTEIRO:
 *  id estável e `reconcileById` no default, porque o servidor re-emite o MESMO
 *  bloco com o eco `chosen` (retry de cota e turno de sucesso) e ele tem que
 *  atualizar no lugar, não empilhar um card novo. */
export const flightMultiOffersEntry: GenUiEntry<Extract<ChatUi, { kind: 'flight_multi_offers' }>> =
  {
    kind: 'flight_multi_offers',
    slot: 'chat',
    policy: {
      productOf: () => 'flight',
      // TODOS os trechos: a re-emissão pós-cota PARCIAL volta com o trecho que
      // caiu sem `chosen`, e é exatamente nele que a pessoa precisa reescolher —
      // congelar o card ali mataria a recuperação. Roteiro completo = recibo.
      frozenWhen: (ui) => ui.legs.every((leg) => leg.chosen !== undefined),
    },
    render: ({ ui, note, readOnly, dispatch }) => (
      <FlightMultiOffersCard
        legs={ui.legs}
        challengeId={ui.challengeId}
        blockId={ui.id}
        note={note}
        readOnly={readOnly}
        search={ui.search}
        dispatch={dispatch}
      />
    ),
  };
